/* eslint-disable no-empty-pattern */
import React from "react";
import { Button, IconButton, SwipeableDrawer, Box } from "@mui/material";
import { Form, Formik } from "formik";
import InputField from "Components/CommonComponents/InputField";
import Icon from "../CommonComponents/CustomIcon";
import { AssestsIcon, IconColors } from "../../Constants/AssetsConstants";

const ManageMetersComponent = ({ openDrawer, handleopenDrawer }) => {
  return (
    <SwipeableDrawer
      anchor="right"
      open={openDrawer}
      onClose={handleopenDrawer}
      //  onOpen={handleopenDrawer}
      PaperProps={{
        style: { backgroundColor: "#e3fff5" },
      }}
    >
      {/* <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onMouseLeave={handleClose}
      BackdropProps={{
        sx: {
          backgroundColor: "#0000004D",
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          minWidth: 620,

          "& .MuiMenu-list": {
            padding: 0,
          },
        },
      }}
      PaperProps={{
        elevation: 0,

        onMouseLeave: handleClose,
        style: {
          backgroundColor: "#e3fff5",
        },

        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    > */}
      <Box
        sx={{
          paddingTop: "65px",
        }}
        role="presentation"
      >
        <div className="user-menu-container">
          <div className="user-menu-header-container w-100">
            <p className="user-menu-header-text">Header</p>
            <Button
              variant="contained"
              style={{
                borderRadius: "27px",
                backgroundColor: "#538dd6",
                fontFamily: "PoppinsMedium",
              }}
              size="small"
              className="d-flex"
            >
              done
            </Button>
          </div>
          <div>
            <Formik
              //initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={() => {}}
              enableReinitialize
            >
              {({}) => (
                <Form>
                  <div className="row">
                    <div className="col-md-6">
                      <InputField label="Name" width="90%" name="name" />
                    </div>
                    <div className="col-md-6">
                      <InputField label="Building Name" width="90%" name="name" />
                    </div>
                    <div className="col-md-6">
                      <InputField label="Phone" width="90%" type="number" />
                    </div>
                    <div className="col-md-6">
                      <InputField label="Address-1" width="90%" name="emailAddress" />
                    </div>
                    <div className="col-md-6">
                      <InputField label="Email" width="90%" name="name" />
                    </div>
                    <div className="col-md-6">
                      <InputField label="Address-2" width="90%" name="name" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="add-meter-container">
            <p className="add-meter-text">Add Meter</p>
            <IconButton>
              <Icon icon={AssestsIcon.ICON_PLUS} size={18} color={IconColors.ICON_GREEN} />
            </IconButton>
          </div>
        </div>
      </Box>
      {/* </Menu> */}
    </SwipeableDrawer>
  );
};

export default ManageMetersComponent;
